import { useEffect, useState } from 'react'
import withDetailsContainer from './withDetailsContainer'
import { getMemberKey, getNodeLabel, splitUid } from 'Services/WeaverUtils'
import { Dropdown, Menu, Popover, Tooltip } from 'antd'
import Feather from '@sysunite/react-feather'
import { InlineKeyEditor, WeaverLoading } from 'Components'
import WeaverService from 'Services/WeaverService'
import { RELATION_VIEW, QUERY } from 'Types'
import { useDispatch } from 'react-redux'
import { setCurrentItem } from 'Actions/explore'

OpenRelationDropdown = ({ direction, relation, node, children }) ->
  dispatch = useDispatch()
  <Dropdown
    overlay={
      <Menu>
        <Menu.Item
          onClick={->
            query = new Weaver.Query().hasRelationOut('*', node)
            query["hasRelation#{direction}"](relation.key)
            query["select#{direction}"](relation.key)
            dispatch(
              setCurrentItem({
                type: QUERY
                data: { query }
              })
            )
          }>
          Open { getNodeLabel(node) } nodes in graph that have this relation
        </Menu.Item>
        <Menu.Item
          onClick={->
            query = new Weaver.Query().hasRelationOut('*', node)
            query["hasNoRelation#{direction}"](relation.key)
            dispatch(
              setCurrentItem({
                type: QUERY
                data: { query }
              })
            )
          }>
          Open { getNodeLabel(node) } nodes in graph that <b>{ "don't" }</b> have this relation.
        </Menu.Item>
      </Menu>
    }>
    <a>{ children } <Feather type="chevron-down" /></a>
  </Dropdown>

export default RelationDetails = ({ data }) ->
  [item, setItem] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      setLoading(true)
      [id, graph] = splitUid(data.relation.from)
      fromNode = await new Weaver.Query().restrict(id).inGraph(graph).first()
      [id, graph] = splitUid(data.relation.to)
      toNode = await new Weaver.Query().restrict(id).inGraph(graph).first()
      setItem({ data.relation..., fromNode, toNode })
      setLoading(false)
    )()
    undefined
  , [data])

  return <WeaverLoading style={{ margin: '33%' }} /> if loading
  Details = withDetailsContainer(item, { nodeIsEditable: false })

  <Details>
    {[
      {
        key: 'from'
        label: 'From'
        value:
          <OpenRelationDropdown direction="Out" relation={item} node={item.fromNode}>
            { getNodeLabel(item.fromNode) }
          </OpenRelationDropdown>
      }, {
        key: 'to'
        label: 'To'
        value:
          <OpenRelationDropdown direction="In" relation={item} node={item.toNode}>
            { getNodeLabel(item.toNode) }
          </OpenRelationDropdown>
      }, {
        key: 'relkey'
        label: 'Key'
        value: (
          <span className="edit-type-icon-container">
            { item.key }
            {
              if WeaverService.userCanEdit()
                <a className="edit-attr-and-rel-key-icon">
                  <InlineKeyEditor isEnabled={true} label={ item.key } type={RELATION_VIEW}/>
                </a>
            }
          </span>
        )
      }
    ]}
  </Details>

